import React from "react"
import ReactFullpage from '@fullpage/react-fullpage';
import { SymptomsLayout } from 'layouts/SymptomsLayout';
import { PageLayout } from 'layouts/PageLayout';

import * as Footer from 'sawada.components/Footer';
import * as FooterStyles from '../Footer.module.scss';
import * as FooterTimeTableStyles from '../FooterTimeTable.module.scss'


import { Cost } from 'components/Cost';

import ImgIcon from 'images/menu_icon.png';
import ImgWhiplash from 'images/high_voltage2.png';

const Title = () => (  
  <SymptomsLayout.TitleConatiner>
    <PageLayout.Title>むち打ち</PageLayout.Title>
    <SymptomsLayout.TitleText>
      鞭を打つように首に不可が掛かって<strong>首周辺を損傷</strong>すること。<br/>
      骨折など骨に異常のない捻挫。<strong>頸椎捻挫</strong>という病名がつけられる。<br/>
      神経を傷つけると、<strong>手足のしびれ</strong>や<strong>倦怠感</strong>などの症状も併発。
    </SymptomsLayout.TitleText>
  </SymptomsLayout.TitleConatiner>
)

const TreatmentImagesContainer = (props) => (  
    <SymptomsLayout.ImageContainer>
      <SymptomsLayout.ImageContainerTitle>{ props.title }</SymptomsLayout.ImageContainerTitle>
      <SymptomsLayout.ImageContainerImage alt={ props.title } image={ props.image }/>
      <p>{ props.children }</p>
    </SymptomsLayout.ImageContainer>
)

const TreatmentContainer = (props) => (  
  <SymptomsLayout.ImageContainer>
    <SymptomsLayout.ImageContainerTitle>{ props.title }</SymptomsLayout.ImageContainerTitle>
    <p>{ props.children }</p>
  </SymptomsLayout.ImageContainer>
)

const TreatmentImages = () => (  
  <>
    <TreatmentContainer title={ "ハイボルテージ" }>
      従来の電気治療法に比べ、身体の奥深い患部への直接のアプローチができます<br/>
      高い鎮痛効果と即効性が望めます
    </TreatmentContainer>
    <TreatmentImagesContainer title={ "超音波治療" } image={ ImgWhiplash }>
      一秒間に何百万回もの振動を起こすことでミクロマッサージ効果を発生し、疾患部の痛みを和らげます
    </TreatmentImagesContainer>
  </>
)

const Treatment = () => (  
  <SymptomsLayout.Contents>
    <SymptomsLayout.SubTitle alt={ "むち打ちの治療方法" } image={ ImgIcon }>治療方法</SymptomsLayout.SubTitle>
    <p>
      深部の筋肉に対しアプローチ<br/>
      ・ハイボルテージ、超音波などの機器の使用<br/>
      ・手技による治療
    </p>
    <TreatmentImages/>
  </SymptomsLayout.Contents>
)

const Times = () => ( 
  <>
    <SymptomsLayout.SubTitle alt={ "むち打ちの治療時間・回数" } image={ ImgIcon }>治療時間・回数</SymptomsLayout.SubTitle>
    <p>
      <strong>1回30～40分の治療</strong>
      <br/>
      （電気１５分 ＋ 手技１５分程度）<br/>
      ※ 時間短縮集中型の治療あり<br/>
      交通事故などの保険適用時、施術日数に制限なし
      （１日１回まで）
    </p>
  </>
)
const Period = () => ( 
  <>
    <SymptomsLayout.SubTitle alt={ "むち打ちの治療期間" } image={ ImgIcon }>治療期間</SymptomsLayout.SubTitle>
    <p>
      <strong>完治</strong>もしくは、<strong>症状固定（※）診断</strong>が出るまで
    </p>
    <p>
      むち打ちの場合、６ヶ月以上が一般的<br/><br/>
      ※「症状固定」<br/>
      治療を続けても症状の改善が望めない状態
    </p>
  </>
)


const MainSection = () => ( 
  <section>
    <SymptomsLayout>
      <Title/>
      <SymptomsLayout.FlexContainer>
        <Treatment/>
        <SymptomsLayout.Contents>
          <Times/>
          <Period/>
        </SymptomsLayout.Contents>
      </SymptomsLayout.FlexContainer>
    </SymptomsLayout>
  </section>
)

const PriceSection = () => ( 
    <section>
      <SymptomsLayout>
        <Cost/>
      </SymptomsLayout>
    </section>
)

const FooterSection = () => ( 
  <section >
    <Footer.Container styles={ FooterStyles }>
      <Footer.PageLinks/>
      <Footer.Info>
        <Footer.Title/>
        <Footer.FooterTel/>
        <Footer.TimeTable styles={ FooterTimeTableStyles }/>
        <Footer.Address/>
        <Footer.FacebookLink/>
      </Footer.Info>
    </Footer.Container>
  </section>
)


export default function Sprain() {
  return ( 
      <>
      <ReactFullpage
      //fullpage options
      licenseKey = { '240F6328-47E64C97-82A0A364-AE0D2783' }
      scrollingSpeed = { 700 } /* Options here */
      sectionSelector = "section"
      scrollOverflow = "true"
      paddingTop = "40px"
      sectionsColor = {['#fff','#fff','#1db0d1']}
      render={
          ({ state, fullpageApi }) => {
            return (
              <ReactFullpage.Wrapper >
                <MainSection  />
                <PriceSection/>
                <FooterSection/>
              </ReactFullpage.Wrapper>
            );
          }
        }
        /> 
      </>
    )
}
